<template>
  <div
    class="basic_searchs"
    :class="{is_mb_system : module.data.isMbSystem === 'true'}"
    :style="{
      '--backgroundColor': iconColor ? iconColor : $store.state.myRender.common.theme_color
    }"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart module_edit_btn" @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)">
      <my_edit_btn :module="module" :title='$t("widgets_basic_article_classification_index_336")'></my_edit_btn>
      <my_edit_btn :module="module" tabName="animation" :title='$t("widgets_basic_article_classification_edit_330")' v-if="$store.state.app.view_pattern === 'pc'"></my_edit_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div
      class="module_content height_fill"
      :style="{
        height: infor.height + 'px'
      }"
    >
      <div class="searchs_content" v-if="pc_widgets_infor.styleType === 'type_6'" :class="[pc_widgets_infor.styleType, pc_widgets_infor.styleClass]">
        <div class="searchs_btn_content" @mouseenter="hideSite">
          <template v-if="$store.state.app.view_pattern === 'mb'">
            <div v-if="source === 'mobile_header'" class="mobile_header_search">
              <svg class="search_icon">
                <use :xlink:href="`../../../static/image/search_icon.svg`"></use>
              </svg>
            </div>
            <a
              v-else
              @click="showSite"
              class="iconfont icon-fangdajing"
              :style="{
                lineHeight: infor.height - 14 + 'px'
              }"
              ></a>
          </template>
          <template v-else>
            <a
                @click="showTooltip"
                class="ccc iconfont icon-fangdajing"
                :style="{
                  lineHeight: infor.height - 14 + 'px'
                }"
              ></a>
            <div class="searchTooltip" @mouseleave="showTooltip(true)" v-show="isShowTooltip">
              <div class="searchs_content type_2 "  :class="[pc_widgets_infor.styleClass]"
              :style="{
                borderColor:pc_widgets_infor.styleClass=='withBorder'?$store.state.myRender.common.theme_color:'',
                borderWidth:pc_widgets_infor.styleClass=='withBorder'?'2px':'0px',
                borderStyle:'solid',
              }">
                <div class="searchs_input_content" @mousedown.stop>
                  <el-input v-model="keyWords" @keyup.enter.native='searchWords(keyWords)' :placeholder="module.data.listArr.placeholder" @focus="showSite"></el-input>
                </div>
                <div class="searchs_btn_content" @click="searchWords(keyWords)" :style="{
                  'backgroundColor': $store.state.myRender.common.theme_color
                }">
                  <span
                    class="iconfont icon-fangdajing"
                    :style="{
                      lineHeight: 40 + 'px'
                    }"
                  ></span>
                </div>
              </div>

              <div class="site_search_dropdown showPart site_search_pc" @mouseenter="showSite"  @mousedown.stop v-if="(module.data.listArr.hot_keyWords.length > 0 || historyWords.length > 0)&&$store.state.app.view_pattern === 'pc'&&pc_widgets_infor.styleType === 'type_6'">
                <div class="siteContent">
                  <div class="hot_keyWords" v-show="module.data.listArr.hot_keyWords.length > 0 && pc_widgets_infor.showHotKey === 'true'">
                    <p class="lineTitle">{{ getLang($t('widgets_basic_searchs_index_2844')) }}</p>
                    <div class="search_content">
                      <p class="search_content_words" @mouseenter="hasColor($event)" @mouseleave="loseColor($event)" @click="searchWords(item.words)" v-for="item in module.data.listArr.hot_keyWords" :key="item.key">{{ item.words }}</p>
                    </div>
                  </div>
                  <div class="history_words" v-show="historyWords.length > 0 && pc_widgets_infor.showHistory === 'true'">
                    <p class="clearHistory lineTitle" v-if="historyWords.length > 0" @click="clearHistory">{{ getLang($t('widgets_basic_searchs_index_2845')) }}</p>
                    <p class="lineTitle">{{ getLang($t('components_historical_record_index_2193')) }}</p>
                    <div class="search_content">
                      <p class="search_content_words" @mouseenter="hasColor($event)" @mouseleave="loseColor($event)" @click="searchWords(item)" v-for="(item, index) in historyWords" :key="index">{{ item }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="arrowPart"></div>
              
            </div>
          </template>
        </div>
      </div>
      <div
        v-else
        class="searchs_content"
        :class="[pc_widgets_infor.styleType, pc_widgets_infor.styleClass]"
        :style="{
          borderRadius: pc_widgets_infor.borderRadius[pc_widgets_infor.borderRadius.radio_val].value + 'px',
        }"
      >
        <div class="searchs_input_content" @mousedown.stop>
          <el-input v-model="keyWords" @keyup.enter.native='searchWords(keyWords)' :placeholder="module.data.listArr.placeholder" @focus="showSite" @blur="hideSite"></el-input>
        </div>
        <div class="searchs_btn_content" @click="searchWords(keyWords)">
          <a v-if='pc_widgets_infor.styleType === "type_0"||pc_widgets_infor.styleType === "type_1"'
              :style="{
              lineHeight: infor.height - 14 + 'px'
            }">{{ getLang($t('router_default_90')) }}</a>
          <a
          v-else
            class="iconfont icon-fangdajing"
            :style="{
              lineHeight: infor.height - 14 + 'px'
            }"
          ></a>
        </div>
      </div>
    </div>
    <div class="site_search_dropdown showPart site_search_pc" v-if="(module.data.listArr.hot_keyWords.length > 0 || historyWords.length > 0)&&$store.state.app.view_pattern === 'pc'&&pc_widgets_infor.styleType !== 'type_6'">
      <div class="siteContent">
        <div class="hot_keyWords" v-show="module.data.listArr.hot_keyWords.length > 0 && pc_widgets_infor.showHotKey === 'true'">
          <p class="lineTitle">{{ getLang($t('widgets_basic_searchs_index_2844')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item.words)" v-for="item in module.data.listArr.hot_keyWords" :key="item.key">{{ item.words }}</p>
          </div>
        </div>
        <div class="history_words" v-show="historyWords.length > 0 && pc_widgets_infor.showHistory === 'true'">
          <p class="clearHistory lineTitle" v-if="historyWords.length > 0" @click="clearHistory">{{ getLang($t('widgets_basic_searchs_index_2845')) }}</p>
          <p class="lineTitle">{{ getLang($t('components_historical_record_index_2193')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item)" v-for="(item, index) in historyWords" :key="index">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="site_search_dropdown site_search_pc hiddenPart" v-if="(module.data.listArr.hot_keyWords.length > 0 || historyWords.length > 0)&&$store.state.app.view_pattern === 'pc'">
      <div class="siteContent">
        <div class="hot_keyWords" v-show="module.data.listArr.hot_keyWords.length > 0 && pc_widgets_infor.showHotKey === 'true'">
          <p class="lineTitle">{{ getLang($t('widgets_basic_searchs_index_2844')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item.words)" v-for="item in module.data.listArr.hot_keyWords" :key="item.key">{{ item.words }}</p>
          </div>
        </div>
        <div class="history_words" v-show="historyWords.length > 0 && pc_widgets_infor.showHistory === 'true'">
          <p class="clearHistory lineTitle" v-if="historyWords.length > 0" @click="clearHistory">{{ getLang($t('widgets_basic_searchs_index_2845')) }}</p>
          <p class="lineTitle">{{ getLang($t('components_historical_record_index_2193')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item)" v-for="(item, index) in historyWords" :key="index">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="site_search_dropdown showPart site_search_mb" v-if="(module.data.listArr.hot_keyWords.length > 0 || historyWords.length > 0 || pc_widgets_infor.styleType === 'type_6') && $store.state.app.view_pattern === 'mb'">
      <div class="mb_search_partLine">
        <div class="site_searchLine">
          <el-input
              :placeholder="module.data.listArr.placeholder"
              v-model="keyWords"
              v-on:keyup.enter.native="searchWords(keyWords)">
              <i slot="prefix" class="el-input__icon el-icon-search" @click="searchWords(keyWords)" style="cursor: pointer;"></i>
            </el-input>
        </div>
        <div class="site_closeLine" @click="closeSiteMb">
          <p>{{ getLang($t('view_public_topbar_11')) }}</p>
        </div>
      </div>
      <div class="siteContent">
        <div class="hot_keyWords" v-show="module.data.listArr.hot_keyWords.length > 0 && pc_widgets_infor.showHotKey === 'true'">
          <p class="lineTitle">{{ getLang($t('widgets_basic_searchs_index_2844')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item.words)" v-for="item in module.data.listArr.hot_keyWords" :key="item.key">{{ item.words }}</p>
          </div>
        </div>
        <div class="history_words" v-show="historyWords.length > 0 && pc_widgets_infor.showHistory === 'true'">
          <p class="clearHistory lineTitle" v-if="historyWords.length > 0" @click="clearHistory">{{ getLang($t('widgets_basic_searchs_index_2845')) }}</p>
          <p class="lineTitle">{{ getLang($t('components_historical_record_index_2193')) }}</p>
          <div class="search_content">
            <p class="search_content_words" @click="searchWords(item)" v-for="(item, index) in historyWords" :key="index">{{ item }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import Cookies from 'js-cookie';
export default {
  name: 'basic_searchs',
  data() {
    return {
      isShowTooltip: false,
      isHover: false,
      keyWords:'',
      historyWords: Cookies.get('historyWords_wm') ? Cookies.get('historyWords_wm').split(',') : []
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    },
    iconColor: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
  },
  computed: {
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr;
    },
    baseColor(){
      return this.$store.state.myRender.common.theme_color
    },
  },
  methods: {
    showTooltip(hide =false){
      this.isShowTooltip = hide === true ? false : !this.isShowTooltip      
    },
    hasColor(e){
      let color = this.baseColor
      e.currentTarget.style.backgroundColor = color
    },
    loseColor(e){
      e.currentTarget.style.backgroundColor = '#f3f3f3'
      // e.currentTarget.style.color = '#333'
      // e.currentTarget.css({'background':'#f3f3f3','color':'#333'})

    },
    searchWords(words) {
      console.log('searchWords123', words);
      if (words === '') {
        this.$message.warning(this.getLang(i18n.t('widgets_basic_searchs_index_2846')));
        return false;
      } else {
        // let data = {
        //   border:this.infor.styleClass,
        //   styleType:this.infor.styleType,
        //   searchType:this.module.data.listArr.searchType,
        //   searchParams:this.module.data.listArr.searchParam,
        // }
        let historyWords = this.historyWords;
        if (historyWords.indexOf(words) === -1) {
          if(historyWords.length>=5){
            historyWords.length = 4
          }
          historyWords.splice(0,0,words);
        }
        historyWords = historyWords.join(',');
        Cookies.set('historyWords_wm', historyWords);
        //让朱加个根据id查询的接口

        this.$store.commit('app/set_now_page', 'search');
        console.log(this.$store.state.searchs_params.searchs_params_list);
        if (this.module.data.listArr.searchContent === 'both') {
          for (let item in this.$store.state.searchs_params.searchs_params_list) {
            this.module.data.listArr.searchParam.push(item);
          }
        }
        let hot_keyWords = this.listArr.hot_keyWords.map(e=>{
          return e.key
        })
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            // customClass: 'del_dialog',
            appendToBody: true
          })
            .then(() => {
              this.$router.push({
                path: '/search',
                query: {
                  border: this.infor.styleClass,
                  styleType: this.infor.styleType,
                  searchType: this.module.data.listArr.searchType,
                  searchParams: this.module.data.listArr.searchParam,
                  searchWords: words,
                  placeholder: this.module.data.listArr.placeholder,
                  showhistoryWords: this.pc_widgets_infor.showHistory,
                  showHotKey:this.pc_widgets_infor.showHotKey,
                  widgets_id:this.module.widgets_id,
                  hot_keyWords:hot_keyWords.join(',')
                }
              });
            })
            .catch(() => {});
        } else {
          this.$router.push({
            path: '/search',
            query: {
              border: this.infor.styleClass,
              styleType: this.infor.styleType,
              searchType: this.module.data.listArr.searchType,
              searchParams: this.module.data.listArr.searchParam,
              searchWords: words,
              placeholder: this.module.data.listArr.placeholder,
              showhistoryWords: this.pc_widgets_infor.showHistory,
              showHotKey:this.pc_widgets_infor.showHotKey,
              widgets_id:this.module.widgets_id,
              hot_keyWords:hot_keyWords.join(',')
            }
          });
        }

        Cookies.set('searchParams_wm', this.module.widgets_id);
        // this.$store.commit('preview/SET_module','search:index');
        // this.templet.p_init();
      }
    },
    clearHistory() {
      this.historyWords = [];
      Cookies.set('historyWords_wm', '');
    },
    hideSite() {
      if(this.$store.state.app.view_pattern === 'pc'){
        if(this.pc_widgets_infor.styleType === 'type_6'){
          $('.site_search_dropdown.showPart')
            .css('height', 0);
        }else{
          $('#u' + this.module.widgets_id)
            .find('.site_search_dropdown')
            .css('height', 0);
        }
      }
    },
    closeSiteMb(){
      $('#u' + this.module.widgets_id)
        .find('.site_search_dropdown')
        .css('height', 0);
    },
    showSite() {
      console.log('showSite123');
      if(this.$store.state.app.view_pattern === 'pc'){

        if(this.pc_widgets_infor.styleType === 'type_6'){
          $('.site_search_dropdown.showPart')
            .animate({ height: 'auto' }, 1000)
            .css('height', 'auto');
        }else{
          let domHeight = $('#u' + this.module.widgets_id).offset().top
          let documentHeight = document.body.clientHeight
          if(documentHeight - domHeight < $('#u' + this.module.widgets_id).find('.site_search_dropdown.hiddenPart').height()){
            $('#u' + this.module.widgets_id)
              .find('.site_search_dropdown.showPart')
              .css('top',-$('#u' + this.module.widgets_id).find('.site_search_dropdown.hiddenPart').height())
              .animate({ height: 'auto' }, 1000)
              .css('height', 'auto');
          }else{
            $('#u' + this.module.widgets_id)
              .find('.site_search_dropdown.showPart')
              .animate({ height: 'auto' }, 1000)
              .css('height', 'auto');
          }
        }
        // debugger
      }else if(this.$store.state.app.view_pattern === 'mb'){
        $('#u' + this.module.widgets_id)
          .find('.site_search_dropdown.showPart')
          .animate({ height: '667px' }, 1000)
          .css('height', '667px')
          .find('input')
          .focus();
      }

    },
    module_isHover(val) {
      this.isHover = val;
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.basic_searchs {
  position: relative;
  &.is_mb_system{
    display: none !important;
  }
  .tooptipPart {
    display: none;
    z-index: 999;
  }
}
.module_content {
  height: 100%;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
}
.searchs_content.type_6{
  border: none;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
  .searchs_btn_content{
    box-sizing: border-box;
    min-width: 50px;
    // border-radius: 3px;
    background-color: transparent;
    color: var(--backgroundColor);
    .search_icon{
      width: 24px;
      height: 24px;
      margin-top: 7px;
      margin-left: 14px;
    }
    a{

      color: var(--backgroundColor);
    }
    span{
      color: #fff;
      line-height: 39px;
      font-size: 24px;
    }
    .searchTooltip{
      transform-origin: center top;
      z-index: 2023;
      position: absolute;
      top: 44px;
      left: -184px;
      border-radius: 4px;
      padding: 10px;
      -webkit-box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
      box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
      background-color: #fff;
      width: 240px;
    }
  }
  .arrowPart{
      border-width: 6px;    
      border-bottom-color: #fff;
      border-top-color: #fff;
      border-top-width: 0;
      -webkit-box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
      box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
      top: -5px;
      right: 13px;
  }
  .arrowPart, .arrowPart::after{
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .arrowPart::after{
    content: " ";
    border-width: 5px;
    border-bottom-color: #FFFFFF;
    margin-left: -5px;
    border-top-width: 0;
  }
}
.tooltipPart{
  .site_search_dropdown{
    position: relative;
    top: 0;
    left: 0;
    z-index: 999;
    height: 0;
    width: calc(100%);
    margin-left: 0;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: none;
    // border: 1px solid #eee;
  }
}
.searchs_content.type_6.solidColor{
  background-color: transparent;
}
.searchs_content.type_3, .searchs_content.type_2{
  border-color: #ebebeb;
}
.searchs_content.type_5 {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
  -moz-box-orient: horizontal;
  -moz-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}
.searchs_content.type_5,
.searchs_content.type_4 {
  border-color: #ebebeb;
  .searchs_btn_content {
    background-color: #fff;
    a {
      color: var(--backgroundColor);
    }
  }
}
.searchs_content.type_5 {
  .searchs_btn_content {
    a {
      color: #808080;
    }
  }
}
.searchs_content {
  display: flex;
  height: 100%;
  border-radius: 3px;
  overflow: hidden;
  box-sizing: border-box;
  border-style: solid;
  border-width: 2px;
  font-size: 0;
  border-color: var(--backgroundColor);
  .searchs_input_content {
    flex: 1;
    box-sizing: border-box;
    .el-input {
      height: 100%;
    }
  }
  .searchs_input_content /deep/ .el-input__inner {
    height: 100%;
    border-radius: 0;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border: none;
  }
  .searchs_btn_content {
    box-sizing: border-box;
    
    height: 100%;
    background: var(--backgroundColor);
    a {
      display: block;
      width: 50px;
      cursor: pointer;
      font-size: 25px;
      color: #fff;
      height: 100%;
      padding: 0 12.5px;
    }
  }
}

.searchs_content.type_1 {
  background: var(--backgroundColor);
}
.searchs_content.type_5 .searchs_input_content /deep/ .el-input__inner{
  padding-left: 0;
}
.searchs_content.type_0 .searchs_btn_content a,.searchs_content.type_1 .searchs_btn_content a{
  font-size: 15px;
  padding: 0px;
  margin: 0px 4px 0px 4px;
  text-align: center;
}
.searchs_content.solidColor {
  border-width: 0;
  background-color: #f1f1f1;
  .searchs_input_content /deep/ .el-input__inner {
    background-color: #f1f1f1;
  }
}
.searchs_content.solidColor.type_5,
.searchs_content.solidColor.type_4 {
  .searchs_btn_content {
    background-color: #f1f1f1;
    a {
      color: var(--backgroundColor);
    }
  }
}
.searchs_content.solidColor.type_5 {
  .searchs_btn_content {
    a {
      color: #808080;
    }
  }
}
.module_banner {
  border-bottom: 1px solid #e5e5e5;
  .module_banner_text {
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 0 6px;
    color: var(--backgroundColor);
  }
}
.site_search_dropdown {
  display: block;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 3px);
  left: 50%;
  z-index: 999;
  height: 0;
  width: calc(100% - 30px);
  margin-left: calc((100% - 30px) / -2);
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
  border-radius: 4px;
  .siteContent {
    padding: 20px 17px 0;
  }
  .lineTitle {
    font-size: 13px;
    color: #999;
  }
  .clearHistory {
    float: right;
    cursor: pointer;
  }
  .search_content {
    padding: 20px 0;
    .search_content_words {
      max-width: 150px;
      display: inline-block;
      margin: 0 7px 7px 0;
      padding: 5px 10px;
      border-radius: 2px;
      background-color: #f3f3f3;
      color: #333;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }
    .search_content_words:hover {
      color: #fff;
      background-color: var(--backgroundColor);
    }
  }
}
.site_search_dropdown.site_search_mb{
  display: block;
  position: fixed;
  width: 100%;
  height: 0;
  background: #fff;
  overflow: hidden;
  left: 0;
  top: 0;
  margin-left:0;
  z-index: 1999;
  .mb_search_partLine{
    padding: 20px 17px 0;
    .site_searchLine{
      display: inline-block;
      vertical-align: top;
      width: 80%;
      margin-right: 5%;
    }
    .site_closeLine{
      display: inline-block;
      vertical-align: top;
      line-height: 40px;
      cursor: pointer;
      p{
        line-height: 40px;
      }
    }
    /deep/ .el-input__inner{
      background-color: #f3f3f3;
      border-radius: 999px;
    }
    /deep/ .el-input__icon{
      color: #808080;
    }
  }
}
.hiddenPart{
  opacity: 0 !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 0 !important;
  height: auto !important;
  pointer-events: none;
}
</style>
<style>
.basic_searchs .searchs_content.type_1 .el-input__inner{
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_searchs/index.vue